import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AttachmentFile } from '#models';
import { AttachmentListItemComponent } from '../attachment-list-item/attachment-list-item.component';

@Component({
  selector: 'app-attachment-list',
  imports: [TranslatePipe, AttachmentListItemComponent],
  templateUrl: './attachment-list.component.html',
  styleUrl: './attachment-list.component.scss',
})
export class AttachmentListComponent {
  titleKey = input.required<string>();
  items = input<AttachmentFile[]>([]);

  canDelete = input(true);
  canDownload = input(true);

  expandItem = output<AttachmentFile>();
  downloadItem = output<AttachmentFile>();
  deleteItem = output<AttachmentFile>();
}
